import React from "react";
import clsx from "clsx";

const FeaturesWrapper = ({ children, horizontal, four, fullWidth }) => {
    const classes = clsx(
        "card-features",
        { "card-features--horizontal": horizontal },
        { "card-features--four-features": four },
        { "card-features--full-width": fullWidth }
    )

    return (
        <div className={classes}>
            {children}
        </div>
    )
}

export default FeaturesWrapper;